import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import jsbridge from '@xpeng/js-bridge'
import 'normalize.css';
import './index.css';
import App from './app';
import InitRun from '../../common/initial';
import { initGdp } from '../../utils/gio-report'

initGdp();
InitRun();

const callHandlerOrigin = jsbridge.callHandler;
jsbridge.callHandler = (method, params) => {
  console.log(`====== bridge callHandler start =====`)
  console.log(`method: ${method}`);
  console.log('params: ');
  console.log(params);
  return callHandlerOrigin.call(jsbridge, method, params).then(res => {
    console.log(`method: ${method}`);
    console.log('response: ');
    console.log(res);
    console.log(`====== bridge callHandler end ======`)
    return res;
  }).catch(err => {
    console.log(`method: ${method}`);
    console.log('error: ');
    console.log(err);
    console.log(`====== bridge callHandler end ======`)
    throw err;
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
